<template>
    <div :class="{ main: true, 'fvs-theme': isFvsTheme()}">
        <div>
            <transition name="fade">
                <router-view></router-view>
            </transition>
        </div>
    </div>
</template>
<style lang="scss">
    @import "@/../sass/_root.scss";
</style>
<script>
    import {getBrandingOptions} from "@/utils/getBrandingOptions";

    export default {
        methods: {
          getBrandingOptions,
          isFvsTheme() {
            return getBrandingOptions().whiteLabel === 'FVS';
          }
        },
    }
</script>